module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-5-Australia-Landing-Page.ddbc9617.webp";